import { alertsConstants } from "../../constants/client";

export const alerts = {
  alertListing,
  alertListingSuccess,
  alertListingFailure,

  alertSave,
  alertSaveSuccess,
  alertSaveFailure,

  alertDelete,
  alertDeleteSuccess,
  alertDeleteFailure
};

function alertListing(payload) {
  return { type: alertsConstants.ALERT_LISTING_REQUEST, payload };
}

function alertListingSuccess(payload) {
  return { type: alertsConstants.ALERT_LISTING_SUCCESS, payload };
}

function alertListingFailure(error) {
  return { type: alertsConstants.ALERT_LISTING_FAILURE, error };
}

function alertSave(payload) {
  return { type: alertsConstants.ALERT_SAVE_REQUEST, payload };
}

function alertSaveSuccess(payload) {
  return { type: alertsConstants.ALERT_SAVE_SUCCESS, payload };
}

function alertSaveFailure(error) {
  return { type: alertsConstants.ALERT_SAVE_FAILURE, error };
}


function alertDelete(payload) {
  return {
    type: alertsConstants.ALERT_DELETE_REQUEST,
    payload: { id: payload[0] } //currently only one item will be there in array
  };
}

function alertDeleteSuccess(payload) {
  return { type: alertsConstants.ALERT_DELETE_SUCCESS, payload };
}

function alertDeleteFailure(error) {
  return { type: alertsConstants.ALERT_DELETE_FAILURE, error };
}